<template>
    <!-- Main Wrapper -->
    <div class="main-wrapper">
        <layouts></layouts>
        <sidebar-menu></sidebar-menu>
        <div class="page-wrapper">
            <div class="content">
                <pageaddheader :title="title" :title1="title1" />

                <!-- /product list -->
                <div class="card">
                    <div class="card-body">
                        
                        <div class="d-flex align-items-center gap-3 mb-3">

                            <div class="search-set">
                                
                                <div class="search-input">
                                    <a class="btn btn-searchset"><img src="../../../assets/img/icons/search-white.svg"
                                            alt="img" /></a>
                                    <div id="DataTables_Table_0_filter" class="dataTables_filter">
                                        <label>
                                            <input type="search" class="form-control form-control-sm"
                                                placeholder="Search..." aria-controls="DataTables_Table_0"
                                                v-model="query" />
                                        </label>
                                    </div>
                                </div>

                                
                            </div>
                            
                        </div>
                        <!-- /Filter -->
                        
                         <!-- :scroll="{ x: 1500 }" -->
                        <div class="table-responsive">
                            <a-table :columns="columns" :data-source="filteredData" @change="handleTableChange" :pagination="pagination" :loading="loading"  >
                                <template #bodyCell="{ column, record }">
                                    <template v-if="column.key === 'no'">
                                        <div class="productimgname" @click="edit(record); goPage('editemployee');">
                                            {{ record.no }}
                                        </div>
                                    </template>
                                    
                                    <template v-if="column.key === 'nama_lokasi'">
                                        <div class="" >
                                            <!---<a href="javascript:void(0);" class="product-img">
                                                <img :src="require('../../../assets/img/product/' + record.img)"
                                                    alt="product" />
                                            </a>-->
                                            <a href="javascript:void(0);" class="link-click" @click="edit(record); goPage('editemployee');">{{ record.nama_lokasi }}</a>
                                        </div>
                                    </template>
                                    <template v-if="column.key === 'employee_id2'">
                                        <div class="" >
                                            <!---<a href="javascript:void(0);" class="product-img">
                                                <img :src="require('../../../assets/img/product/' + record.img)"
                                                    alt="product" />
                                            </a>-->
                                            <a href="javascript:void(0);" class="link-click" @click="edit(record); goPage('editemployee');">{{ record.employee_id2 }}</a>
                                        </div>
                                    </template>
                                    <template v-if="column.key === 'nama'">
                                        <div class="d-flex align-items-center gap-2" >
                                            <div class="product-img" >
                                            
                                           
                                            
                                                <img :src="record.foto_ktp" :alt="record.nama" style=" object-fit: cover; border-radius: 50%;" />
                                            </div>
                                            <a href="javascript:void(0);" class="link-click" @click="edit(record); goPage('editemployee');">
                                                {{ record.nama }}
                                            </a>
                                        </div>
                                    </template>
                                    <template v-if="column.key === 'telepon'">
                                        <div class="link-click" @click="edit(record); goPage('editemployee');">
                                            {{ record.telepon }}
                                        </div>
                                    </template>
                                    <template v-if="column.key === 'tipe_kerja'"  >
                                        <div class="link-click" @click="edit(record); goPage('editemployee');">
                                            {{ record.tipe_kerja }}
                                        </div>
                                    </template>
                                    <template v-if="column.key === 'nama_departemen'">
                                        <div class="productimgname" >
                                            <span v-if="record.nama_departemen == 0">-</span>
                                            <span v-else>{{ record.nama_departemen }}</span>

                                        </div>
                                    </template>

                                    <template v-if="column.key === 'nama_jabatan'"  >
                                        <div class="productimgname" >
                                            <span v-if="record.nama_jabatan == 0">-</span>
                                            <span v-else>{{ record.nama_jabatan }}</span>

                                        </div>
                                    </template>
                                    
                                    
                                    <template v-else-if="column.key === 'action'">
                                        <!-- <a class="me-3" @click="show_izitoast">
                                            <img src="../../../assets/img/icons/eye.svg" alt="img" />
                                        </a> -->
                                        
                                        <router-link class="me-3 btn btn-success btn-sm" to="editaianalisis" @click="edit(record);">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-stars text-white" viewBox="0 0 16 16">
                                            <path d="M7.657 6.247c.11-.33.576-.33.686 0l.645 1.937a2.89 2.89 0 0 0 1.829 1.828l1.936.645c.33.11.33.576 0 .686l-1.937.645a2.89 2.89 0 0 0-1.828 1.829l-.645 1.936a.361.361 0 0 1-.686 0l-.645-1.937a2.89 2.89 0 0 0-1.828-1.828l-1.937-.645a.361.361 0 0 1 0-.686l1.937-.645a2.89 2.89 0 0 0 1.828-1.828zM3.794 1.148a.217.217 0 0 1 .412 0l.387 1.162c.173.518.579.924 1.097 1.097l1.162.387a.217.217 0 0 1 0 .412l-1.162.387A1.73 1.73 0 0 0 4.593 5.69l-.387 1.162a.217.217 0 0 1-.412 0L3.407 5.69A1.73 1.73 0 0 0 2.31 4.593l-1.162-.387a.217.217 0 0 1 0-.412l1.162-.387A1.73 1.73 0 0 0 3.407 2.31zM10.863.099a.145.145 0 0 1 .274 0l.258.774c.115.346.386.617.732.732l.774.258a.145.145 0 0 1 0 .274l-.774.258a1.16 1.16 0 0 0-.732.732l-.258.774a.145.145 0 0 1-.274 0l-.258-.774a1.16 1.16 0 0 0-.732-.732L9.1 2.137a.145.145 0 0 1 0-.274l.774-.258c.346-.115.617-.386.732-.732z"/>
                                            </svg> AI Summary
                                        </router-link>
                                       

                                    </template>
                                </template>
                            </a-table>
                        </div>
                    </div>
                </div>
                <!-- /product list -->
            </div>
        </div>
    </div>
 


</template>
<script>

import Cookies from "js-cookie";
import axios from "axios";
import { base_url, AlertPopup2, AlertBottom, appendForm, timeout, selectedBranch, goPage } from "@/assets/js/function";
import XLSX from "xlsx/dist/xlsx.full.min.js";
import { watch } from 'vue';


export default {
    data() {
        return {
            filter: false,
            title: "AI Analyst",
            title1: "View Summerize ",
           
           

            //data
            data: [
            ],
            columns: [
                {
                    title: "No",
                    dataIndex: "no",
                    key: "no",
                    fixed: 'left',
                    // width: 60,
                    sorter: {
                        compare: (a, b) => {
                            a = a.no.toLowerCase();
                            b = b.no.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
              
                {
                    title: "Name",
                    dataIndex: "nama",
                    key: "nama",
                    fixed: 'left',
                    // width: 200,
                    sorter: {
                        compare: (a, b) => {
                            a = a.nama.toLowerCase();
                            b = b.nama.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Employee Id",
                    dataIndex: "employee_id2",
                    key: "employee_id2",
                    // width: 150,
                    sorter: {
                        compare: (a, b) => {
                            a = a.employee_id2.toLowerCase();
                            b = b.employee_id2.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Location",
                    dataIndex: "nama_lokasi",
                    key: "nama_lokasi",
                    // width: 150,
                    sorter: {
                        compare: (a, b) => {
                            a = a.nama_lokasi.toLowerCase();
                            b = b.nama_lokasi.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Department",
                    dataIndex: "nama_departemen",
                    key: "nama_departemen",
                    // width: 150,
                    sorter: {
                        compare: (a, b) => {
                            a = a.nama_departemen.toLowerCase();
                            b = b.nama_departemen.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Job Title",
                    dataIndex: "nama_jabatan",
                    key: "nama_jabatan",
                    // width: 150,
                    sorter: {
                        compare: (a, b) => {
                            a = a.nama_jabatan.toLowerCase();
                            b = b.nama_jabatan.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Employee Status",
                    dataIndex: "status_employee",
                    key: "status_employee",
                    // width: 150,
                    sorter: {
                        compare: (a, b) => {
                            a = a.status_employee.toLowerCase();
                            b = b.status_employee.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Join Date",
                    dataIndex: "join_date",
                    key: "join_date",
                    // width: 150,
                    sorter: {
                        compare: (a, b) => {
                            a = a.join_date.toLowerCase();
                            b = b.join_date.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                
                {
                    title: "Phone Number",
                    dataIndex: "telepon",
                    key: "telepon",
                    // width: 150,
                    sorter: {
                        compare: (a, b) => {
                            a = a.telepon.toLowerCase();
                            b = b.telepon.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Gender",
                    dataIndex: "gender",
                    key: "gender",
                    // width: 120,
                    sorter: {
                        compare: (a, b) => {
                            a = a.gender.toLowerCase();
                            b = b.gender.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Religion",
                    dataIndex: "religion",
                    key: "religion",
                    // width: 120,
                    sorter: {
                        compare: (a, b) => {
                            a = a.religion.toLowerCase();
                            b = b.religion.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Marital Status",
                    dataIndex: "marital_status",
                    key: "marital_status",
                    // width: 150,
                    sorter: {
                        compare: (a, b) => {
                            a = a.marital_status.toLowerCase();
                            b = b.marital_status.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                

                {
                    title: "Action Trigger",
                    key: "action",
                    fixed: 'right', // to freeze at right
                    sorter: false,
                    // width: 150,
                },
            ],


            tanggal_terminate: "",
            alasan_terminate: "",
            id_terminate: "",
            id_tujuan_mutasi: "",

            isanviz: "",

            currentData: {},

            pagination: {
                current: 1,
                pageSize: 10,
                showSizeChanger: false
            },

            //filter
            query: "",
            loading: true,

            tujuanMutasiList: [],
        };
    },
    created() {
        const token = Cookies.get("token_refresh");
        this.config = {
            headers: { Authorization: `Bearer ` + token },
            timeout: 30000,
        }

        const branch = parseInt(localStorage.getItem("selectedBranch")) || 0;

        //Update local and shared state
        this.filter = branch;
        selectedBranch.value = branch;

        localStorage.setItem('actionState', 'view')

        this.index();
    },

    mounted() {
        watch(selectedBranch, () => {
            this.index()
        }, { immediate: true })

        const savedPage = localStorage.getItem("lastPage");
        if (savedPage) {
            this.pagination.current = parseInt(savedPage);
        }
    },

    computed: {
        filteredData() {
            if (!this.query) {
                return this.data;
            }

            const lowerCaseQuery = this.query.toLowerCase();

            return this.data.filter(item =>
                String(item.nama || '').toLowerCase().includes(lowerCaseQuery) ||
                String(item.telepon || '').includes(this.query) ||
                String(item.tipe_kerja || '').toLowerCase().includes(lowerCaseQuery) ||
                String(item.nama_departemen || '').toLowerCase().includes(lowerCaseQuery) ||
                String(item.nama_jabatan || '').toLowerCase().includes(lowerCaseQuery) ||
                String(item.nama_shift || '').toLowerCase().includes(lowerCaseQuery) ||
                String(item.nama_lokasi || '').toLowerCase().includes(lowerCaseQuery) ||
                String(item.employee_id || '').toLowerCase().includes(lowerCaseQuery) ||
                String(item.employee_id2 || '').toLowerCase().includes(lowerCaseQuery)
            );
        }
    },
    methods: {
        goPage,



        showModal(modal_name) {
            this.$refs[modal_name].classList.add('show');
            this.$refs[modal_name].style.display = 'block';
        },

        hideModal2(modal_name) {
            this.$refs[modal_name].classList.remove('show');
            this.$refs[modal_name].style.display = 'none';

        },

        handleTableChange(pagination) {
            this.pagination = pagination; // keep pagination reactive
            localStorage.setItem("lastPage", pagination.current);
        },


        async index() {
            this.loading = true;

            let formData = new FormData();
            appendForm(formData)

            const api = base_url + '/v3/employees/index';
            const res = await axios.post(api, formData, { timeout });
            const data = res.data;
            const employee = data.data.data_employee;

            if(data.status){
                this.data = [];

                employee.forEach((item, index) => {

                    //departemen search name
                    const departemen_index = data.data.data_departemen.findIndex((record) => record.id == item.departemen);
                    let nama_departemen_index = "";
                    if (departemen_index > -1) {
                        nama_departemen_index = data.data.data_departemen[departemen_index].nama;
                    } else {
                        nama_departemen_index = '-';
                    }

                    // jabatan search name 
                    const jabatan_index = data.data.data_jabatan.findIndex((record) => record.id == item.jabatan);
                    let nama_jabatan_index = "";
                    if (jabatan_index > -1) {
                        nama_jabatan_index = data.data.data_jabatan[jabatan_index].nama;
                    } else {
                        nama_jabatan_index = '-';
                    }


                    let item_prepare = {
                        ...item, no: (index + 1), nama_departemen: nama_departemen_index, nama_jabatan: nama_jabatan_index
                        
                    };
                    this.data.push(item_prepare);
                });

                this.loading = false;
               
                
            }else {
                AlertPopup2("error", "", data.message, true, 1500);
            }

           

        },
        addNumberToObjects(objArray) {
            for (let i = 0; i < objArray.length; i++) {
                const newObj = { No: i + 1, ...objArray[i] };
                objArray[i] = newObj;
            }
            return objArray;
        },
        export_employee() {
            ShowLoading();
            if (process.env.NODE_ENV === "development") {
                this.api = base_url + 'employees/export';
            } else {
                this.api = base_url + 'employees/export';
            }
            axios
                .post(this.api, '', this.config)
                .then((response) => {
                    if (response.data.status == true) {
                        response.data.data = this.addNumberToObjects(response.data.data);
                        for (var i = 0; i < response.data.data.length; i++) {
                            delete response.data.data[i]["id"];
                            delete response.data.data[i]["created_at"];
                            delete response.data.data[i]["updated_at"];
                        }

                        // Create a new workbook
                        const wb = XLSX.utils.book_new();
                        // Create a new worksheet
                        const ws = XLSX.utils.json_to_sheet(response.data.data);
                        // Add the worksheet to the workbook
                        XLSX.utils.book_append_sheet(wb, ws, 'Employee');
                        // Convert the workbook to an XLSX file and download it
                        XLSX.writeFile(wb, 'Employee' + ".xlsx");
                        CloseLoading();
                    }


                    if (response.data.status == false) {
                        AlertPopup("error", "", response.data.message, 1500, false);
                    }
                })
                .catch((error) => {
                    ErrorConnectionTimeOut(error);
                });

        },

        edit(record) {
            localStorage.setItem('currentEmployee', JSON.stringify(record));
        },
        
        delete2() {
            ShowLoading();
            let formData = new FormData();
            formData.append("id", this.id_terminate);
            // const tanggal = this.tanggal_terminate.toISOString().split('T')[0];
            var dateObj = new Date(this.tanggal_terminate);

            // Format the date manually (e.g., yyyy-mm-dd)
            var year = dateObj.getFullYear();
            var month = ('0' + (dateObj.getMonth() + 1)).slice(-2); // Add leading zero for single digits
            var day = ('0' + dateObj.getDate()).slice(-2); // Add leading zero for single digits

            var tanggal = `${year}-${month}-${day}`;
            formData.append("tanggal", tanggal);
            formData.append("alasan", this.alasan_terminate);

            // for (let [key, value] of formData.entries()) {
            //   console.log(`${key}: ${value}`);
            // }

            if (process.env.NODE_ENV === "development") {
                this.api = base_url + 'employee_delete';
            } else {
                this.api = base_url + 'employee_delete';
            }

            axios
                .post(this.api, formData, this.config)
                .then((response) => {
                    if (response.data.status == true) {
                        const index = this.data.findIndex((record) => record.id === this.id_terminate);
                        this.data.splice(index, 1);
                        CloseLoading();
                        AlertBottom(response.data.message);
                        this.hideModal2('terminate');

                    }
                    if (response.data.status == false) {
                        AlertPopup("error", "", response.data.message, 1500, false);
                    }
                })
                .catch((error) => {

                    ErrorConnectionTimeOut(error);
                });


        },


        

        mutasi_data() {


            ShowLoading();
            if (this.id_tujuan_mutasi == "") {
                AlertPopup("error", "", "please choose the location", 1500, false);
                return true;
            }
            let formData = new FormData();
            formData.append("id_employee", this.id_terminate);
            formData.append("id_company_tujuan", this.id_tujuan_mutasi);
            // const tanggal = this.tanggal_terminate.toISOString().split('T')[0];
            var dateObj = new Date(this.tanggal_terminate);

            // Format the date manually (e.g., yyyy-mm-dd)
            var year = dateObj.getFullYear();
            var month = ('0' + (dateObj.getMonth() + 1)).slice(-2); // Add leading zero for single digits
            var day = ('0' + dateObj.getDate()).slice(-2); // Add leading zero for single digits

            var formattedDate = `${year}-${month}-${day}`;

            formData.append("tanggal", formattedDate);
            formData.append("alasan_mutasi", this.alasan_terminate);

            // for (let [key, value] of formData.entries()) {
            //     console.log(`${key}: ${value}`);
            // }

            if (process.env.NODE_ENV === "development") {
                this.api = base_url + 'employees/mutasi';
            } else {
                this.api = base_url + 'employees/mutasi';
            }

            axios
                .post(this.api, formData, this.config)
                .then((response) => {
                    if (response.data.status == true) {
                        const index = this.data.findIndex((record) => record.id === this.id_terminate);
                        this.data.splice(index, 1);
                        CloseLoading();
                        AlertBottom(response.data.message);
                        this.hideModal2('mutasi');

                    }
                    if (response.data.status == false) {
                        AlertPopup("error", "", response.data.message, 1500, false);
                    }
                })
                .catch((error) => {

                    ErrorConnectionTimeOut(error);
                });


        },
        terminate(id) {
            this.id_terminate = id;
            this.tanggal_terminate = new Date();
        },
        mutasi(id) {
            this.id_terminate = id;
            this.tanggal_terminate = new Date();
        }
    },
    name: "productlist",
};
</script>

<style scoped>
.ant-tooltip {
    display: none !important;
}

.ant-table-cell {
    cursor: pointer !important;
}

.link-click {
  color: black;
  text-decoration: none;
}

.link-click:hover {
    color: #08b77e;
    text-decoration: underline;
}

</style>